import JWT from "expo-jwt";
import moment from "moment";
import qs from "qs";
import { useLocation } from "react-router-dom";

import PsLabel from "./PsLabel";
import PsSelect from "./PsSelect";
import NoData from "./NoData";
import MuiModalWindow from "./MuiModalWindow";
import MuiConfirmWindow from "./MuiConfirmWindow";

export const appName = "KalviSalai";
export const PS_WEB = "21R91541sD5411H0G5";

export const SITE_FILE_DOWNLOAD_DIR = "files_list/";

/*export const baseUrl = process.env.REACT_APP_BASE_URL;
export const siteUrl = process.env.REACT_APP_SITE_URL;
export const S3_BUCKET_HOME_PATH = process.env.REACT_APP_S3_BUCKET_HOME_PATH; //end trailing slash is must
export const APP_TYPE = process.env.REACT_APP_TYPE;
export const DB_POSTFIX = process.env.REACT_APP_DB_POSTFIX;
export const DENOMINATION = process.env.REACT_APP_DENOMINATION; 
export const THEME_VARIANT = "primary";//*/

/*export const baseUrl = "http://localhost/git/tndlserp/api/";
//export const baseUrl = "https://collegeerp.kalvisalai.in/api/";
export const siteUrl = "https:///erp.tndls.ac.in/";
export const S3_BUCKET_HOME_PATH = "svn/"; //end trailing slash is must
export const APP_TYPE = "";
export const DENOMINATION = "";
export const DB_POSTFIX = "tndls";
export const THEME_VARIANT = "primary";*/

// export const baseUrl = "http://localhost/git/tndlserp/api/";
export const baseUrl = "https://portal.tndls.ac.in/api/";
export const siteUrl = "https://portal.tndls.ac.in/";
export const S3_BUCKET_HOME_PATH = "tndls/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "tndls";
export const THEME_VARIANT = "primary";

/*export const baseUrl = "https://collegeerp.kalvisalai.in/api/";
export const siteUrl = "https://collegeerp.kalvisalai.in/";
export const S3_BUCKET_HOME_PATH = "v2demo/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "clgerp"; 
export const THEME_VARIANT = "primary";//*/

// RAC WOMEN - THIRUVARUR
/*export const baseUrl = "https://racollege.kalvisalai.in/manage/api/";
export const siteUrl = "https://racollege.kalvisalai.in/";
export const S3_BUCKET_HOME_PATH = "racwomen/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "rac";
export const DENOMINATION = "";
export const THEME_VARIANT = "primary"; // */

// Government Law College - Thrichy
/*export const baseUrl = "https://glctry.tndls.ac.in/api/";
export const siteUrl = "https://glctry.tndls.ac.in/";
export const S3_BUCKET_HOME_PATH = "trichy/"; //end trailing slash is must
export const APP_TYPE = '';
export const DB_POSTFIX = "glctry"; 
export const THEME_VARIANT = "primary";//*/

// SVN College - Madurai
/*export const baseUrl = "https://svncollege.kalvisalai.in/api/";
export const siteUrl = "https://svncollege.kalvisalai.in/";
export const S3_BUCKET_HOME_PATH = "svn/"; //end trailing slash is must
export const APP_TYPE = "";
export const DENOMINATION = "";
export const DB_POSTFIX = "svn";
export const THEME_VARIANT = "warning"; //

//St.Johns College - Tirunelveli
/*export const baseUrl = "https://stjohnscollege.kalvisalai.in/api/";
export const siteUrl = "https://stjohnscollege.edu.in/";
export const S3_BUCKET_HOME_PATH = "stjohns/"; //end trailing slash is must
export const APP_TYPE = "";
export const DENOMINATION = "";
export const DB_POSTFIX = "stjohns";
export const THEME_VARIANT = "error"; // */

//TNSOEL - CHENNAI (LAW UNIVERSITY)
/*export const baseUrl = "https://soelerp.tndalu.ac.in/api/";
export const siteUrl = "https://soelerp.tndalu.ac.in/";
export const S3_BUCKET_HOME_PATH = "soel/"; //end trailing slash is must
export const APP_TYPE = "";
export const DENOMINATION = "";
export const DB_POSTFIX = "soel"; 
export const THEME_VARIANT = "primary";// */

//TNDLS - TAMIL NADU LAW COLLEGE SAAS
/*export const baseUrl = "https://portal.tndls.ac.in/api/";
export const siteUrl = "https://portal.tndls.ac.in/";
export const S3_BUCKET_HOME_PATH = "tndls/"; //end trailing slash is must
export const APP_TYPE = "SAAS";
export const DB_POSTFIX = "tndls"; 
export const THEME_VARIANT = "primary";//  */

// ANNAI GROUP OF INSTITUTIONS - SAAS
/*export const baseUrl = "https://agi.kalvisalai.in/api/";
export const siteUrl = "https://agi.kalvisalai.in/";
export const S3_BUCKET_HOME_PATH = "annaigi/"; //end trailing slash is must
export const APP_TYPE = "SAAS";
export const DB_POSTFIX = "annaigi";*
export const THEME_VARIANT = "primary";/ */

//SPORTS UNIVERSITY COLLEGe
/*export const baseUrl = "https://erp.tnpesuonline.in/api/";
export const siteUrl = "https://erp.tnpesuonline.in/";
export const S3_BUCKET_HOME_PATH = "erptnpesu/"; //end trailing slash is must
export const APP_TYPE = "";
export const DENOMINATION = "";
export const DB_POSTFIX = "erptnpesu";
export const THEME_VARIANT = "error"; //*/

//Balagan Saraswathi Arts and Science college for women
/*export const baseUrl = "https://bsaswomen.kalvisalai.in/api/";
export const siteUrl = "https://bsaswomen.kalvisalai.in/";
export const S3_BUCKET_HOME_PATH = "bsaswomen/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "bsaswomen"; 
export const THEME_VARIANT = "primary";// */

// Sasurie Group of Institutions
/*export const baseUrl = "https://portal.sasurie.com/api/";
export const siteUrl = "https://portal.sasurie.com/";
export const S3_BUCKET_HOME_PATH = "sasurie/"; //end trailing slash is must
export const APP_TYPE = "SAAS";
export const DENOMINATION = "";
export const DB_POSTFIX = "sasurie";
export const THEME_VARIANT = "error"; // */

// St.Xaviers college palayamkottai
/*export const baseUrl = "https://stxavierstn.in/api/";
export const siteUrl = "https://stxavierstn.in/";
export const S3_BUCKET_HOME_PATH = "xavier/"; //end trailing slash is must
export const APP_TYPE = "";
export const DENOMINATION = "";
export const DB_POSTFIX = "";
export const THEME_VARIANT = "error"; // */

// NAAS Madurai Arts & Science
/*export const baseUrl = "https://naasmadurai.kalvisalai.in/api/";
export const siteUrl = "https://naasmadurai.kalvisalai.in/";
export const S3_BUCKET_HOME_PATH = "naas/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = ""; 
export const THEME_VARIANT = "primary";// */

// Thanga pazham group of Institutions
/*export const baseUrl = "https://stgroup.kalvisalai.in/api/";
export const siteUrl = "https://stgroup.kalvisalai.in/";
export const S3_BUCKET_HOME_PATH = "stgroup/"; //end trailing slash is must
export const APP_TYPE = "SAAS";
export const DB_POSTFIX = "stgroup"; 
export const THEME_VARIANT = "primary";// */

//DBC_Maram Manipoor - Donbosco College
/*export const baseUrl = "https://dbcmaram.kalvisalai.in/api/";
export const siteUrl = "https://dbcmaram.kalvisalai.in/";
export const S3_BUCKET_HOME_PATH = "dbcmaram/"; //end trailing slash is must
export const APP_TYPE = "";
export const DENOMINATION = "";
export const DB_POSTFIX = ""; 
export const THEME_VARIANT = "primary";// */

// NSCAS - THENI
/*export const baseUrl = "https://erp.nscollege.org.in/api/";
export const siteUrl = "https://nscollege.org.in/";
export const S3_BUCKET_HOME_PATH = "nscas/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "";
export const DENOMINATION = "";
export const THEME_VARIANT = "primary"; // */

//SARAHTUCKER COLLEGE - TVL
/* export const baseUrl = "https://portal.sarahtuckercollege.edu.in/api/";
export const siteUrl = "https://sarahtuckercollege.edu.in/";
export const S3_BUCKET_HOME_PATH = "stc_v2/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "stc";
export const DENOMINATION = "";
export const THEME_VARIANT = "pink"; */

//SARAHTUCKER COLLEGE - TVL
/*export const baseUrl = "https://stc.kalvisalai.in/api/";
export const siteUrl = "https://sarahtuckercollege.edu.in/";
export const S3_BUCKET_HOME_PATH = "stc_v2/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "stc";
export const DENOMINATION = "";
export const THEME_VARIANT = "pink"; // */

// KAMARAJ COLLEGE - TUTUCORIN
/*export const baseUrl = "https://portal.kamarajcollege.ac.in/api/";
export const siteUrl = "https://kamarajcollege.ac.in/";
export const S3_BUCKET_HOME_PATH = "kctuty/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "";
export const DENOMINATION = ""; 
export const THEME_VARIANT = "primary";//*/

// CHRISTOPHER COLLEGE
/*export const baseUrl = "https://christophercollege.kalvisalai.in/apiv3/";
export const siteUrl = "https://christophercollege.kalvisalai.in/";
export const S3_BUCKET_HOME_PATH = "christo/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = ""; 
export const THEME_VARIANT = "primary";//*/

//St.Jerome's College - Nagercoil
/*export const baseUrl = "https://portal.stjeromes.in/api/";
export const siteUrl = "https://portal.stjeromes.in/";
export const S3_BUCKET_HOME_PATH = "stjeromes/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "";
export const DENOMINATION = "";
export const THEME_VARIANT = "primary";//*/

//GVN Institute of Medical Science - Trichy
/*export const baseUrl = "https://portal.gvnims.edu.in//api/";
export const siteUrl = "https://gvnims.edu.in//";
export const S3_BUCKET_HOME_PATH = "gvnims/"; //end trailing slash is must
export const APP_TYPE = "MULTICLG";
export const DB_POSTFIX = "";
export const DENOMINATION = ""; 
export const THEME_VARIANT = "primary";//*/

//ANJAC COLLEGE - SIVAKASI
/*export const baseUrl = "https://irms.anjac.edu.in/api/";
export const siteUrl = "https://anjac.edu.in/";
export const S3_BUCKET_HOME_PATH = "anjac/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "";
export const DENOMINATION = "";
export const THEME_VARIANT = "primary"; //*/

//PARASAKTHI COLLEGE TENKASI,
/*export const baseUrl = "https://sriparasakthicollege.kalvisalai.in/apiv2/";
export const siteUrl = "https://sriparasakthicollege.edu.in/";
export const S3_BUCKET_HOME_PATH = "sriparas/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "";
export const DENOMINATION = "";
export const THEME_VARIANT = "primary"; //*/

//PARASAKTHI COLLEGE TENKASI,
/*export const baseUrl = "https://spcerp.kalvisalai.in/apiv2/";
export const siteUrl = "https://sriparasakthicollege.edu.in/";
export const S3_BUCKET_HOME_PATH = "sriparas/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "";
export const DENOMINATION = "";
export const THEME_VARIANT = "primary"; //*/

// MANGAYARKARASI COLLEGE - MADURAI
/*export const baseUrl = "https://portal.mcw-madurai.ac.in/api/";
export const siteUrl = "https://portal.mcw-madurai.ac.in/";
export const S3_BUCKET_HOME_PATH = "mcwmdu/"; //end trailing slash is must
export const APP_TYPE = "";
export const DB_POSTFIX = "";
export const DENOMINATION = "";
export const THEME_VARIANT = "success"; //*/

export { PsLabel, PsSelect, NoData, MuiModalWindow, MuiConfirmWindow };

export const DEVELOPER = {
  COMPANY_NAME: "Peace Soft Technologies",
  COMPANY_URL: "https://peacesoft.in",
  APP_NAME: "Kalvisalai College Edition",
  APP_VERSION: "1.0",
  SUPPORT_MOBILE: "+91 9487900120",
  SUPPORT_EMAIL: "peacesoft.developer@gmail.com",
};

export const IMG_MENU_BAR = require("../assets/svg/bar.svg");

export const MOB_ICONS = {
  PAYMENT_SUCCESS_GIF: require("../assets/mob/payment_successfull.gif"),
  PAYMENT_SUCCESS_IMG: require("../assets/mob/payment_successfull.png"),
  KEY_256: require("../assets/mob/key_256.png"),
  PASSWORD_256: require("../assets/mob/password_256.png"),
  SCREEN_LOCK_256: require("../assets/mob/screen_lock_256.png"),
  USERLOGIN_256: require("../assets/mob/userlogin_256.png"),
  USER_BLACK_256: require("../assets/mob/user_black_256.png"),
  NO_USER_250: require("../assets/images/no_user.jpg"),
  MAN_256: require("../assets/mob/man_256.png"),
  WOMAN_256: require("../assets/mob/woman_256.png"),
  CHECKMARK_256: require("../assets/mob/checkmark_256.png"),
  PENDING: require("../assets/mob/pending.png"),
  TIMEMANAGEMENT_256: require("../assets/mob/timemanagement_256.png"),
  CONTRACT_256: require("../assets/mob/contract_256.png"),
  NOTFOUND_256: require("../assets/mob/404_256.png"),
  GEN_ATT_ENTRY_256: require("../assets/mob/gen_att_enntry_256.png"),
  ATT_REPORT_256: require("../assets/mob/att_report_256.png"),
  TRACK_STATUS: require("../assets/mob/gateway.png"),
  STUDENT_TRANSFER: require("../assets/mob/transfer.png"),
  TIMETABLE_256: require("../assets/mob/timetable_256.png"),
  ADD_WITH_PAD_256: require("../assets/mob/add_with_pad_256.png"),
  ADD_WITH_PAD_COLOR_256: require("../assets/mob/spe_entry_color_256.png"),
  GRADUATE_512: require("../assets/mob/graduated_512.png"),
  CONSULTANT_512: require("../assets/mob/consultant_512.png"),
  TEACHER_512: require("../assets/mob/teacher_512.png"),
  FEES: require("../assets/mob/imgData/fees.png"),
  EXAM_FEES_IMG: require("../assets/img/exam_fee_2212.png"),
  ATTENDANCE: require("../assets/mob/imgData/atten.png"),
  REQUEST: require("../assets/mob/imgData/Asset 8result1.png"),
  LEAVE: require("../assets/mob/imgData/service_req_512.png"),
  EVENTS: require("../assets/mob/imgData/events.png"),
  VIEWPENDING: require("../assets/img/view_pending.png"),
  SPLENTRY: require("../assets/img/spl_entry.png"),
  IDCARD: require("../assets/mob/imgData/idcard.png"),
  SEMINOR: require("../assets/mob/imgData/intern.jpeg"),
  FEEDBACK: require("../assets/mob/imgData/feedback.png"),
  INTERN: require("../assets/mob/imgData/Internship-Icon.png"),
  INTERNSHIP: require("../assets/mob/internship_logo.png"),
  STUDENTHALLTICKET: require("../assets/mob/imgData/hallticket.png"),
  EXAM_RESULTS_ICON: require("../assets/mob/imgData/exam_results.png"),
  AWARD: require("../assets/mob/imgData/award.png"),
  //NO_DATA: require("../assets/mob/no_data.png"),
  //NO_DATA: require("../assets/mob/nodata.gif"),
  NO_DATA: require("../assets/mob/empty.svg"),
  // NO_DATA: require("../assets/mob/noitems.svg"),
  TEACHING_STAFF: require("../assets/img/teaching.png"),
  NON_TEACHING_STAFF: require("../assets/img/non_teaching.png"),
  ATTENDANCE_IMG: require("../assets/img/attendance_512.png"),
  FEES_IMG: require("../assets/img/fee_512.png"),
  MY_PROFILE_IMG: require("../assets/img/profile_512.png"),
  CLASS_MONITORING: require("../assets/img/class_monitoring.png"),
  LIBRARY: require("../assets/img/library.png"),
  SEARCH: require("../assets/img/search.png"),
  MARKED_LIST_IMG: require("../assets/img/marked_list_512.png"),
  TIMETABLE_IMG: require("../assets/img/timetable_512.png"),
  GENERAL_ENTRY_IMG: require("../assets/img/new_entry_512.png"),
  STUDENT_LOGIN_IMG: require("../assets/img/student_login_512.png"),
  STAFF_LOGIN_IMG: require("../assets/img/staff_login_512.png"),
  NME_SBE_ENTRY_IMG: require("../assets/img/nme_sbe_entry.png"),
  HOSTEL_512: require("../assets/img/hostel_512.png"),
  STAFF_ATTENDANCE: require("../assets/img/staff_attendance_log.png"),
  STUDENT_SEARCH: require("../assets/img/student_search.png"),
  TASK_512: require("../assets/img/task_management.png"),
  ESTABLISHMENT: require("../assets/img/establishment.png"),
  PAYSLIP: require("../assets/img/payslip.png"),
  SERVICEEORG_ICON: require("../assets/mob/imgData/serviceorg.png"),
  ELECTIVE_ICON: require("../assets/mob/imgData/elective.png"),
  BELL: require("../assets/mob/bell_full.png"),
  ADD_BUTTON: require("../assets/mob/add_button.png"),
  APPROVED: require("../assets/mob/approved.jpg"),
  REJECTED: require("../assets/mob/rejected.jpg"),
  ACCEPT_BUTTON: require("../assets/mob/accept.jpg"),
  CLOSE_BUTTON: require("../assets/mob/close.png"),
  REJECT_BUTTON: require("../assets/mob/reject.jpg"),
  LEAVE_IMG: require("../assets/img/leave.png"),
  PERMISSION_BUTTON: require("../assets/mob/permission.png"),
  ODPERMISSION_BUTTON: require("../assets/mob/odpermission.png"),
  STAFF_PROFILE: require("../assets/mob/staffprofile.png"),

  DOWN_ARROW: require("../assets/mob/down_arrow.png"),
  UP_ARROW: require("../assets/mob/up_arrow.png"),
  CIRCULAR: require("../assets/mob/circular.png"),
  BIRTHDAY: require("../assets/mob/birth_img.png"),
  SERVICEATTENDANCE: require("../assets/mob/serviceorganizationicon.png"),
  BELL_ICON_250: require("../assets/images/bell_icon_250.png"),
  BELL_ICON_80: require("../assets/images/bell_icon_80.png"),
  TRANSPORT_REQUEST_512: require("../assets/mob/trasnport_512.png"),

  GRADIANT_BLUE: {
    FEE_PAYMENT: require("../assets/mob/gradiant/blue_fee_payment.png"),
    FEE_PAID_LOG: require("../assets/mob/gradiant/blue_paid_log.png"),
    BLUE_POLLING: require("../assets/mob/gradiant/blue_polling.png"),
    USER_PROFILE: require("../assets/mob/gradiant/blue_user.png"),
    LIBRARY_BOOKS: require("../assets/mob/gradiant/blue_library.png"),
    HOSTEL: require("../assets/mob/gradiant/blue_hostel.png"),
    BUS: require("../assets/mob/gradiant/blue_bus.png"),
    FORM: require("../assets/mob/gradiant/blue_form.png"),
    SERVICE: require("../assets/mob/gradiant/blue_service.png"),
    RESULT: require("../assets/mob/gradiant/blue_result.png"),
    AWARDS: require("../assets/mob/gradiant/blue-award.png"),
    TICKET: require("../assets/mob/gradiant/blue_ticket.png"),
    LEAVE_REQUEST: require("../assets/mob/gradiant/leave_request.png"),
    SERVICEORGANIZATION: require("../assets/mob/gradiant/blue_serviceorganization.png"),
  },
};

export const BLOOD_GROUPS = [
  "A+",
  "A-",
  "AB+",
  "AB-",
  "A1+",
  "A1-",
  "A2+",
  "A2-",
  "A1B+",
  "A1B-",
  "A2B+",
  "A2B-",
  "B+",
  "B-",
  "O+",
  "O-",
];

export const OCCUPATION_CATEGORY = [
  "State Government Job",
  "Central Government Job",
  "Own Business",
  "In Private Sector",
  "None Above",
];

export const getFileLiveUrl = (item) => {
  let url = siteUrl + SITE_FILE_DOWNLOAD_DIR;
  if (item && item.Key) url += item.Key;
  else url += item;
  let ext = getFileExtension(url);
  ext = lowerCase(ext);
  if (["png", "jpg", "jpeg", "bmp", "gif"].includes(ext))
    url = url.replace("fm", "fm_thumb");
  return url;
};

export const COURSE_TYPE_SORT_ORDER = localSettingsValues(
  "academic_course_types",
  "ug",
)?.split(",");

export const printDocument = (printId) => {
  var content = document.getElementById(printId);
  var pri = document.getElementById("print_frame").contentWindow;
  pri.document.open();
  pri.document.write(
    '<style>@font-face {font-family: "Bookman Old Style";src: local("Bookman Old Style"), url("fonts/bookold.woff") format("woff");}.font-bookman {font-family: "Bookman Old Style", sans-serif;font-size:12px;}</style>',
  );
  pri.document.write(content.innerHTML);

  pri.document.close();
  pri.focus();
  pri.print();
};

export const useQuery = () => {
  const { search } = useLocation();

  return decodeURIComponent(search);
  return decodeURI(search);

  //return React.useMemo(() => new URLSearchParams(search), [search]);
};

export const sleep = (time) =>
  new Promise((resolve) => setTimeout(resolve, time));

export function subtractYears(date, years) {
  date.setFullYear(date.getFullYear() - years);
  return date;
}

export function jsonToQuery(params) {
  return qs.stringify(params);
}
/**
 * setLs
 * to store the user inputs into localStorage
 **/
export function setLs(key, value) {
  localStorage.setItem(key, value);
}

/**
 * getLs
 * to get the stored values from localStorage
 **/
export function getLs(key) {
  return localStorage.getItem(key) || false;
}

export function getAscSortOrder(prop, asNum = false) {
  return function (a, b) {
    if (asNum) {
      if (parseFloat(a[prop]) > parseFloat(b[prop])) {
        return 1;
      } else if (parseFloat(a[prop]) < parseFloat(b[prop])) {
        return -1;
      }
    } else {
      if (a[prop] > b[prop]) {
        return 1;
      } else if (a[prop] < b[prop]) {
        return -1;
      }
    }
    return 0;
  };
}

/**
 * getDescSortOrder
 * to sort an array by particular field
 * @param Property of an array
 * @return int
 */
export function getDescSortOrder(prop, asNum = false) {
  return function (a, b) {
    if (asNum) {
      if (parseFloat(a[prop]) < parseFloat(b[prop])) {
        return 1;
      } else if (parseFloat(a[prop]) > parseFloat(b[prop])) {
        return -1;
      }
    } else {
      if (a[prop] < b[prop]) {
        return 1;
      } else if (a[prop] > b[prop]) {
        return -1;
      }
    }
    return 0;
  };
}

/**
 * removeBothSlash
 * to remove the first and last slash from a string
 * @param1 $string
 * @return String
 */
export function removeBothSlash(str) {
  return str.replace(/^\/|\/$/g, "");
}

/**
 * getAcronym
 * to get first letter of each word in a string
 * @param1 stringValue
 * @param2 noOfChars
 * @return String
 */
export function getAcronym(stringValue, noOfChars = 1) {
  try {
    const str = stringValue; // "Java Script Object Notation";
    const matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    const acronym = matches.join(""); // JSON

    return acronym.slice(0, noOfChars);
  } catch (error) {}
}

/**
 * capitalizeFirst
 * to capitalize the first letter of the word
 * @param1 $str (string)
 * @return string
 */
export function capitalizeFirst(str) {
  if (str == "" || str == null || str == " ") {
    return "";
  }

  str = str.toLowerCase();
  //return str.charAt(0).toUpperCase() + str.slice(1);
  return str.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
}

/**
 * upperCase
 * to conver the string to upper case
 * @param1 $str (string)
 * @return string
 */
export function upperCase(str) {
  if (str == "" || str == null || str == " " || str.length < 1) return "";
  return str.toString().toUpperCase();
}

/**
 * lowerCase
 * to conver the string to lower case
 * @param1 $str (string)
 * @return string
 */
export function lowerCase(str) {
  if (str == "" || str == null || str == " ") return "";
  return str.toString().toLowerCase();
}

/**
 * makeUrl
 * to convert the string into url
 * to remove all the special characters and remove space
 *
 * @param1 $str
 * @return String
 */
export function makeUrl(str) {
  try {
    str = str.replace(/[&\/\\#,+()$~%.\'":*?<>{}]/g, "");
    str = str.replace(/ /g, "-");
    return str.toLowerCase();
  } catch (error) {
    //console.log(error);
  }
}

export function groupByMultiple(array, f) {
  var groups = {};
  array.forEach(function (o) {
    var group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}

export function filterArroyOfItems(arr, query) {
  return arr.filter((el) => el.toLowerCase().includes(query.toLowerCase()));
}

export function findCommonElement(array1, array2) {
  // Loop for array1
  for (let i = 0; i < array1.length; i++) {
    // Loop for array2
    for (let j = 0; j < array2.length; j++) {
      // Compare the element of each and
      // every element from both of the
      // arrays
      if (upperCase(array1[i]) === upperCase(array2[j])) {
        // Return if common element found
        return true;
      }
    }
  }

  // Return if no common element exist
  return false;
}
/**
 * yesorNo
 * to get the value yes or no form the boolean
 * @param1 $val (bool) true,false, 1,0
 * @param2 $withColor (true,false) default false
 * @return String
 */
export function yesorNo(val) {
  if (val == "" || val == null || val == " ") return "No";
  if (val == "1" || val == true) return "Yes";
  return "No";
}

/**
 * isNullOrEmpty
 * to check the given value is null or empty
 * @param $val
 * @return Boolean
 */
export function isNullOrEmpty(val) {
  try {
    if (val == "" || val == null || val == " " || val == NaN) return false;
    return true;
  } catch (error) {
    //console.log(error);
    return true;
  }
}

/**
 * calculateMessageCount
 * to calculate letters count
 * @param1 $textArea
 * @param2 $displayArea
 * @return HTML
 */
export function calculateMsgCount(textAreaId, divId) {
  try {
    const singleSmsLength = 160;
    const ele = document.getElementById(textAreaId);
    const charLength = ele.value.length;
    const msgCount = Math.ceil(charLength / singleSmsLength);
    document.getElementById(divId).innerHTML = `${charLength} / ${msgCount}`;
  } catch (error) {
    //console.log(error);
  }
}

/**
 * momentDate
 * to convert a date format using moment
 * @param1 $date
 * @param2 $format
 * @return date
 */
export function momentDate(value, toFormat = "DD/MMM/YYYY") {
  try {
    if (
      value == "0000-00-00" ||
      value == "" ||
      value == " " ||
      value == null ||
      value == NaN
    ) {
      return "";
    }

    // var d = new Date(value).getTime();
    return moment(value).format(toFormat);
  } catch (error) {
    //console.log(error);
    return "";
  }
}

/**
 * integerKeyPress
 * to handle textbox key press event and check whether the input is integer or not
 *
 * @param EVENT
 * @return NULL
 */
export function integerKeyPress(e) {
  if (e.which != 8 && (e.which < 48 || e.which > 57)) {
    // showAdvice(this, "Integer values only");
    e.preventDefault();
    return false;
  }
}

/**
 * decimalKeyPress
 * to handle textbox key press event and check whether the input is decimal or not
 *
 * @param EVENT
 * @return NULL
 */
export function decimalKeyPress(e) {
  if (e.which != 8 && e.which != 46 && (e.which < 48 || e.which > 57)) {
    // showAdvice(this, "Decimal numbers only");
    e.preventDefault();
    return false;
  }
  if (e.which == 46 && e.target.value.indexOf(".") != -1) {
    // showAdvice(this, "Only one period allowed in decimal numbers");
    e.preventDefault();
    return false; // only one decimal allowed
  }
}

/**
 * lettersOnly
 * to handle textbox key press event and check whether the input is alphabet or not
 *
 * @param EVENT
 * @return NULL
 */
export function lettersOnly(e) {
  const inputValue = e.which;
  // allow letters and whitespaces only.
  if (
    e.which != 8 &&
    !(inputValue >= 65 && inputValue <= 122) &&
    inputValue != 32 &&
    inputValue != 0
  ) {
    e.preventDefault();
    return false;
  }
}

/**
 * nameWithDotAndHypen
 * to handle textbox key press event and check whether the input is alphabet or not
 *
 * @param EVENT
 * @return NULL
 */
export function nameWithDotAndHypen(e) {
  const inputValue = e.which;
  // allow letters and whitespaces only.
  if (
    e.which != 8 &&
    e.which != 45 &&
    e.which != 46 &&
    !(inputValue >= 65 && inputValue <= 122) &&
    inputValue != 32 &&
    inputValue != 0
  ) {
    e.preventDefault();
    return false;
  }
}

/**
 * integerIndMobile
 * to handle textbox key press event and check whether the input is integer and less than 10 characters or not
 *
 * @param EVENT
 * @return NULL
 */
export function integerIndMobile(e) {
  const len = e.target.value.length;
  if (len >= 10) {
    e.preventDefault();
    return false;
  }

  if (e.which !== 8 && (e.which < 48 || e.which > 57)) {
    // showAdvice(this, "Integer values only");
    e.preventDefault();
    return false;
  }
}

export function integerIndPincode(e) {
  const len = e.target.value.length;
  if (len >= 6) {
    e.preventDefault();
    return false;
  }

  if (e.which !== 8 && (e.which < 48 || e.which > 57)) {
    // showAdvice(this, "Integer values only");
    e.preventDefault();
    return false;
  }
}

export function integerAadhar(e) {
  const len = e.target.value.length;
  if (len >= 12) {
    e.preventDefault();
    return false;
  }

  if (e.which !== 10 && (e.which < 48 || e.which > 57)) {
    // showAdvice(this, "Integer values only");
    e.preventDefault();
    return false;
  }
}

export function integerGst(e) {
  const len = e.target.value.length;
  if (len >= 15) {
    e.preventDefault();
    return false;
  }

  if (e.which !== 10 && (e.which < 48 || e.which > 57)) {
    // showAdvice(this, "Integer values only");
    e.preventDefault();
    return false;
  }
}

export function removeExtension(filename) {
  if (filename && filename != "" && filename != null && filename.length > 3)
    return filename.split(".").slice(0, -1).join(".");
}

export function getFileExtension(item) {
  let paths = removeBothSlash(item).split("/");
  let extension = item.substring(item.lastIndexOf("."));
  //let extension = item.split(".").slice(0, -1).join(".");

  return extension.replace(".", "");

  //return fileType;
}

export function calculateAge(dob) {
  try {
    var a = moment();
    var b = moment(moment(dob), "YYYY");
    var diff = a.diff(b, "years");
    return diff;
  } catch (er) {}
}

export function replaceBulk(str, findArray, replaceArray) {
  var i,
    regex = [],
    map = {};
  for (i = 0; i < findArray.length; i++) {
    regex.push(findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, "\\$1"));
    map[findArray[i]] = replaceArray[i];
  }
  regex = regex.join("|");
  str = str.replace(new RegExp(regex, "g"), function (matched) {
    return map[matched];
  });
  return str;
}

/**
 * numberToWords
 * to convert number to words
 *
 * @param1 number (int)
 * @return string
 */
export function numberToWords(amount) {
  if (!amount) return "";
  const words = new Array();
  words[0] = "";
  words[1] = "One";
  words[2] = "Two";
  words[3] = "Three";
  words[4] = "Four";
  words[5] = "Five";
  words[6] = "Six";
  words[7] = "Seven";
  words[8] = "Eight";
  words[9] = "Nine";
  words[10] = "Ten";
  words[11] = "Eleven";
  words[12] = "Twelve";
  words[13] = "Thirteen";
  words[14] = "Fourteen";
  words[15] = "Fifteen";
  words[16] = "Sixteen";
  words[17] = "Seventeen";
  words[18] = "Eighteen";
  words[19] = "Nineteen";
  words[20] = "Twenty";
  words[30] = "Thirty";
  words[40] = "Forty";
  words[50] = "Fifty";
  words[60] = "Sixty";
  words[70] = "Seventy";
  words[80] = "Eighty";
  words[90] = "Ninety";
  amount = amount.toString();
  const atemp = amount.split(".");
  const number = atemp[0].split(",").join("");
  const n_length = number.length;
  let words_string = "";
  if (n_length <= 9) {
    const n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const received_n_array = new Array();
    for (var i = 0; i < n_length; i++) {
      received_n_array[i] = number.substr(i, 1);
    }
    for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
      n_array[i] = received_n_array[j];
    }
    for (var i = 0, j = 1; i < 9; i++, j++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        if (n_array[i] == 1) {
          n_array[j] = 10 + parseInt(n_array[j]);
          n_array[i] = 0;
        }
      }
    }
    let value = "";
    for (var i = 0; i < 9; i++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        value = n_array[i] * 10;
      } else {
        value = n_array[i];
      }
      if (value != 0) {
        words_string += `${words[value]} `;
      }
      if (
        (i == 1 && value != 0) ||
        (i == 0 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Crores ";
      }
      if (
        (i == 3 && value != 0) ||
        (i == 2 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Lakhs ";
      }
      if (
        (i == 5 && value != 0) ||
        (i == 4 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Thousand ";
      }
      if (i == 6 && value != 0 && n_array[i + 1] != 0 && n_array[i + 2] != 0) {
        words_string += "Hundred and ";
      } else if (i == 6 && value != 0) {
        words_string += "Hundred ";
      }
    }
    words_string = words_string.split("  ").join(" ");
  }
  return words_string;
}

export function testResult(
  condition,
  fromRange,
  toRange,
  result,
  gender = false,
) {
  if (!condition) return true;

  try {
    var from = fromRange; //(gender=='F') ? test.female_range_from : test.range_from;
    var to = toRange; //(gender=='F') ? test.female_range_to : test.range_to;
    var cond = condition; //(gender=='F') ? test.female_reference_condition : test.reference_condition;

    if (cond == "Nothing" || cond == "Nill") {
      return false;
    }

    if (cond == "Equal") {
      return result == from || result == to ? true : false;
    }
    if (cond == "Contain") {
      return result == from || result == to ? true : false;
    }
    if (cond == "Less_Than") {
      return parseFloat(result) < parseFloat(from) ||
        parseFloat(result) < parseFloat(to)
        ? true
        : false;
    }
    if (cond == "Greater_Than") {
      return parseFloat(result) > parseFloat(from) ||
        parseFloat(result) > parseFloat(to)
        ? true
        : false;
    }
    if (cond == "Between") {
      return parseFloat(result) >= parseFloat(from) &&
        parseFloat(result) <= parseFloat(to)
        ? true
        : false;
    }
  } catch (er) {}
}

export function getDrCrColor(amt) {
  amt = parseFloat(amt);
  if (amt == 0) return "text-dark";
  else if (amt > 0) return "text-dark-success";
  else if (amt < 0) return "text-dark-danger";
}

export function typeName(str) {
  if (str && str != "" && str != null && str != NaN) {
    str = str.split("_").join(" ");
    str = str.toLowerCase();
    //return str.charAt(0).toUpperCase() + str.slice(1);
    return str.replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  }
  return str;
}

export function startDateOfMonth(month, toFormat = "YYYY-MM-DD") {
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  return moment(firstDay).format(toFormat);
}

export function endDateOfMonth(month, toFormat = "YYYY-MM-DD") {
  var date = new Date();
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return moment(lastDay).format(toFormat);
}

export function emptyRowsToAdd() {
  let height = window.outerHeight;
  return Math.round((window.outerHeight - 250) / 20).toFixed(0);
}

export function queryParam(search) {
  let rv = [];
  if (search.length < 1) {
    return rv;
  }
  let str = search; //props.location.search;
  str = str.replace(/\?/g, "");
  let ar = str.split("&");
  if (ar && ar.length > 0) {
    ar.map((item, i) => {
      let m = item.split("=");
      rv[m[0]] = m[1];
    });
  }
  return rv;
}

export function formToObject(form) {
  const data = new FormData(form);
  const value = Object.fromEntries(data.entries());
  return value;
}

export function yearBySem(num, asText = false) {
  if (num == "1" || num == "2") return asText ? "First Year" : "I-Year";
  else if (num == "3" || num == "4") return asText ? "Second Year" : "II-Year";
  else if (num == "5" || num == "6") return asText ? "Third Year" : "III-Year";
  else if (num == "7" || num == "8") return asText ? "Fourth Year" : "IV-Year";
  else if (num == "9" || num == "10") return asText ? "Fifth Year" : "V-Year";
}

export function semesterValue(num) {
  if (num == "1") return "SEM-I";
  else if (num == "2") return "SEM-II";
  else if (num == "3") return "SEM-III";
  else if (num == "4") return "SEM-IV";
  else if (num == "5") return "SEM-V";
  else if (num == "6") return "SEM-VI";
  else if (num == "7") return "SEM-VII";
  else if (num == "8") return "SEM-VIII";
  else if (num == "9") return "SEM-IX";
  else if (num == "10") return "SEM-X";
}

export function timeTableDayFromNumber(num, type = false) {
  if (num == "1") return type ? "Day 1" : "Mon";
  else if (num == "2") return type ? "Day 2" : "Tue";
  else if (num == "3") return type ? "Day 3" : "Wed";
  else if (num == "4") return type ? "Day 4" : "Thu";
  else if (num == "5") return type ? "Day 5" : "Fri";
  else if (num == "6") return type ? "Day 6" : "Sat";
}

export function customSorting(
  arrayOfDatas,
  sortOrderDatas,
  sortFieldName = "name",
) {
  const sortByObject = sortOrderDatas.reduce((obj, item, index) => {
    return {
      ...obj,
      [item]: index,
    };
  }, {});

  const customSort = arrayOfDatas.sort(
    (a, b) => sortByObject[a[sortFieldName]] - sortByObject[b[sortFieldName]],
  );

  return customSort;
}

export function yearByBatch(batch, maxSem = 6) {
  let currentMonth = moment(new Date()).format("MM");
  let currentYear = moment(new Date()).format("YYYY");
  if (parseInt(currentMonth) < 6) currentYear = parseInt(currentYear) - 1;
  let b = batch.split("-");
  if (b && b.length > 0) {
    if (b[0] == currentYear) return "I-Year";
    else if (b[0] == currentYear - 1 && maxSem > 2) return "II-Year";
    else if (b[0] == currentYear - 2 && maxSem > 4) return "III-Year";
    else if (b[0] == currentYear - 3 && maxSem > 6) return "IV-Year";
    else if (b[0] == currentYear - 4 && maxSem > 8) return "V-Year";
  } else return "";
}

export function objectToQueryString(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export function localTime(time) {
  if (!time || time.length < 1) return null;
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
}

export function formatFileSize(bytes, decimalPoint) {
  if (bytes == 0) return "0 Bytes";
  var k = 1000,
    dm = decimalPoint || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function bulkReplace(str, findArray, replaceArray) {
  try {
    var i,
      regex = [],
      map = {};
    for (i = 0; i < findArray.length; i++) {
      regex.push(findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, "\\$1"));
      map[findArray[i]] = replaceArray[i];
    }
    regex = regex.join("|");
    str = str.replace(new RegExp(regex, "g"), function (matched) {
      return map[matched];
    });
    return str;
  } catch (er) {}
}

export function getDaysBetweenTwoDates(start, end) {
  try {
    /*var start = moment("2016-09-01"), // Sept. 1st
    end = moment("2016-11-02"), // Nov. 2nd*/
    start = moment(start);
    end = moment(end);
    var day = 0; // Sunday
    var result = [];
    var current = start.clone();

    while (current.day(7 + day).isBefore(end)) {
      result.push(current.clone());
    }
    return result;
  } catch (error) {}
}

export function localSettingsValues(key, defaultReturn = false) {
  try {
    /* let settings =
      getLs("adm_settings") && getLs("adm_settings") !== "undefined"
        ? JSON.parse(getLs("adm_settings"))
        : [];*/
    let settings = [];
    if (getLs("adm_settings") && getLs("adm_settings") !== "undefined") {
      let set = getLs("adm_settings");
      if (!set.includes("{")) {
        let decoded = JWT.decode(set, PS_WEB);
        settings = decoded;
      }
    }

    let m = settings && settings.find((item) => item.field_name == key);

    let v = m && m.field_name ? m.field_value : false;

    return v ? v : defaultReturn;
  } catch (er) {}
}

export function ParseFloat(str, length) {
  try {
    str = str.toString();
    if (str.match(/\./g)) str = str.slice(0, str.indexOf(".") + length + 1);
    return Number(str);
  } catch (er) {
    return parseFloat(str).toFixed(2);
  }
}

export const courseName = (courseInfo, fullName = false) => {
  let rv = "";
  try {
    if (courseInfo.course_short_name && !fullName) {
      return courseInfo.course_short_name;
    } else if (courseInfo.course_shortname && !fullName) {
      return courseInfo.course_shortname;
    } else {
      let dname = courseInfo.degree_name || courseInfo.degreename || "";
      rv =
        dname +
        " - " +
        (courseInfo.course_name ||
          courseInfo.name ||
          courseInfo.coursename ||
          "");
      if (
        upperCase(courseInfo.course_type || courseInfo.coursetype) == "REGULAR"
      )
        rv += " (R)";
      else if (
        upperCase(courseInfo.course_type || courseInfo.coursetype) == "SELF"
      )
        rv += " (SF)";
    }
  } catch (er) {}
  return rv;
};

export const commaFormatted = (amount, asFloat = false) => {
  try {
    if (
      amount == NaN ||
      amount == undefined ||
      amount.length < 1 ||
      parseFloat(amount) < 0
    )
      return asFloat ? "0.00" : "0";

    var afterDot = "";
    let m = parseFloat(amount).toFixed(2).split(".");
    var x = m[0];

    x = x.toString();
    var lastThree = x.substring(x.length - 3);
    var otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers != "") lastThree = "," + lastThree;
    var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    if (asFloat && m.length > 0) {
      res = res + "." + m[1];
    }

    return res;
  } catch (er) {
    console.log(er.messsage);
    return asFloat ? parseFloat(amount).toFixed(2) : amount;
  }
};

export const checkToday = (dateValue = false) => {
  try {
    if (dateValue) {
      return momentDate(new Date(), "YYYY-MM-DD") ==
        momentDate(dateValue, "YYYY-MM-DD")
        ? true
        : false;
    }
    return true;
  } catch (er) {
    return false;
  }
};

export const getTodayDate = (dateFormat = "YYYY-MM-DD") =>
  momentDate(new Date(), dateFormat);

export const SkeltonLoop = (loopcount, component) => {
  return Array.from({ length: loopcount }, (v, i) => component);
};

export function attendanceYear(sem) {
  if (sem) {
    if (sem == "1" || sem == "2") return "1";
    else if (sem == "3" || sem == "4") return "2";
    else if (sem == "5" || sem == "6") return "3";
    else if (sem == "7" || sem == "8") return "4";
    else if (sem == "9" || sem == "10") return "5";
  } else return "";
}

export function differenceBetweenTransferDates(
  startDate = new Date(),
  endDate = new Date(),
  item,
  college_uuid,
  report = false,
  diffBy = "days",
) {
  try {
    if (item.is_college_transfer == "0") {
      let diff = moment(endDate).diff(moment(startDate), diffBy);
      if (diff >= 0) {
        return true;
      }
    } else if (
      item.is_college_transfer == "1" &&
      item.transfer_college_uuid == college_uuid
    ) {
      let diff = moment(endDate).diff(moment(startDate), diffBy);
      if (diff > 0 || report) {
        return true;
      }
    } else if (
      item.is_college_transfer == "1" &&
      item.transfer_college_uuid != college_uuid
    ) {
      let diff = moment(endDate).diff(moment(startDate), diffBy);
      if (diff <= 0 || report) {
        return true;
      }
    }
    return false;
  } catch (er) {
    return false;
  }
}
